import {
  SPACE_CATEGORIES,
  type SpaceCategory,
  type SpaceSummary,
} from "@mind-sands/shared";

/** Tailwind classes for a space category entry card / button */
export interface SpaceThemeClasses {
  bg: string;
  hoverBg: string;
  border: string;
  active: string;
}

export interface SpaceTheme {
  label: string;
  emoji: string;
  classes: SpaceThemeClasses;
}

/** Emotion-first entry themes aligned with SpaceCategory */
export const spaceThemes: Record<SpaceCategory, SpaceTheme> = {
  warm: {
    label: "I need warmth",
    emoji: "\u{1F525}",
    classes: {
      bg: "bg-warm-50",
      hoverBg: "hover:bg-warm-100",
      border: "border-warm-200",
      active: "bg-warm-100 border-warm-300 ring-2 ring-warm-200",
    },
  },
  quiet: {
    label: "I need quiet",
    emoji: "\u{1F3D4}\uFE0F",
    classes: {
      bg: "bg-quiet-50",
      hoverBg: "hover:bg-quiet-100",
      border: "border-quiet-200",
      active: "bg-quiet-100 border-quiet-300 ring-2 ring-quiet-200",
    },
  },
  escape: {
    label: "I need to escape",
    emoji: "\u{1F30C}",
    classes: {
      bg: "bg-escape-50",
      hoverBg: "hover:bg-escape-100",
      border: "border-escape-200",
      active: "bg-escape-100 border-escape-300 ring-2 ring-escape-200",
    },
  },
};

/** Display order for the landing page emotion selector */
export const spaceThemeOrder = SPACE_CATEGORIES;

export interface SpaceCategoryGroup {
  category: SpaceCategory;
  theme: SpaceTheme;
  items: SpaceSummary[];
}

/** Group public spaces by emotion. Empty categories are omitted. */
export function groupSpacesByCategory(
  spaces: SpaceSummary[],
): SpaceCategoryGroup[] {
  return spaceThemeOrder
    .map((category) => ({
      category,
      theme: spaceThemes[category],
      items: spaces.filter((space) => space.category === category),
    }))
    .filter((group) => group.items.length > 0);
}
